import { createReducer, on, Action } from '@ngrx/store';
import { ITable } from '@common/models/table';
import * as supplierOtherCreditorActions from '../actions/supplier-other-creditors.actions';
import { SupplierOtherCreditor } from '@feature/suppliers/models/supplier-other-creditor';


export interface State {
    supplierOtherCreditors: SupplierOtherCreditor[];
  loading: boolean;
}

export const initialState: State = {
  supplierOtherCreditors: undefined,
  loading: false
};

const accountsTableReducer = createReducer(
  initialState,
    on(supplierOtherCreditorActions.load, state => ({
    ...state,
    accountTable: undefined,
    loading: true
  })),
    on(supplierOtherCreditorActions.loadComplete, (state, { payload }) => ({
    ...state,
        supplierOtherCreditors: payload,
    loading: false
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return accountsTableReducer(state, action);
}
